export default __webpack_public_path__ + "static/media/otp.e695e1c5.gif";